<template>
  <div class="content">
    <h2 style="margin:20px">开柜记录</h2>
    <!-- 商品表格 -->
    <el-table
      :data="dataList"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>

      <el-table-column label="柜门编号" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.boxNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="回调记录" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.message ? scope.row.message : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付编号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.out_trade_no? scope.row.out_trade_no : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.price? scope.row.price : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作人openid" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.openid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="ejectupdateGoods(scope.row)">修改</el-button> -->
          <el-button
            size="mini"
            type="danger"
            @click="deleteAdmin(scope.row)"
            :disabled="$store.state.supUser.roleId == 1"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { selectOpenBox, deleteOpenBox } from "@/services/openBox/index.js";
export default {
  data() {
    return {
      dataList: [],
      inputTitle: "新增",
      cover: "",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" }
      ],
      form: {},
      dialogFormVisible: false
    };
  },
  created() {

    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      selectOpenBox().then(resp => {

        this.loading = false;
        this.dataList = resp.data;
      });
    },

    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteOpenBox(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.userNanme:hover {
  cursor: pointer;
}
</style>
